import React from 'react';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { getApi } from '../../services/apiServices';
import { toast } from 'react-toastify';

function PlanManagement() {
  const [subscriptions, setSubscriptions] = useState([]);
  const [userCounts, setUserCounts] = useState({
    free: 0,
    premium: 0,
    premiumPlus: 0
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSubscriptions = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getApi('subscription');

      if (response?.statusCode === 200) {
        setSubscriptions(response.data?.subscriptiondetail || []);
        setUserCounts(response.data?.userCounts || {
          free: 0,
          premium: 0,
          premiumPlus: 0
        });
      } else {
        setError(response?.message || 'Failed to fetch subscriptions');
        console.error('Failed to fetch subscriptions:', response?.message);
      }
    } catch (error) {
      setError('Error fetching subscriptions. Please try again.');
      console.error('Error fetching subscriptions:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscriptions();
  }, []);

  const formatPrice = (price, currency = 'USD') => {
    if (price === 0) {
      return 'Free';
    }
    return `$${price}`;
  };

  const formatBooster = (booster) => {
    return booster ? 'Top Visibility' : 'No';
  };

  const formatCallTime = (minutes) => {
    if (minutes >= 1440) {
      return 'Unlimited';
    } else if (minutes >= 60) {
      const hours = Math.floor(minutes / 60);
      const remainingMinutes = minutes % 60;
      return remainingMinutes > 0 ? `${hours}h ${remainingMinutes}m` : `${hours}h`;
    } else {
      return `${minutes}m`;
    }
  };

  if (loading) {
    return (
      <div className="right-section">
        <div className="loader-overlay">
          <span className="loader"></span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="right-section">
        <div className="error-message">
          <h3>Error Loading Data</h3>
          <p>{error}</p>
          <button onClick={fetchSubscriptions} className="btn btn-primary">
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="right-section">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2>Plan Management</h2>
          <button 
            onClick={fetchSubscriptions} 
            className="btn btn-outline-primary"
            disabled={loading}
          >
            {loading ? 'Refreshing...' : 'Refresh'}
          </button>
        </div>
        <div className="row">
          <div className="col-sm-2">
            <div className="dashboard-box">
              <span><img src="/images/active-user.svg" alt="icon" /></span>
              <h4>Free Users</h4>
              <h3>{userCounts.free.toLocaleString()}</h3>
            </div>
          </div>
          <div className="col-sm-2">
            <div className="dashboard-box">
              <span><img src="/images/revenue.svg" alt="icon" /></span>
              <h4>Premium Users</h4>
              <h3>{userCounts.premium.toLocaleString()}</h3>
            </div>
          </div>
          <div className="col-sm-2">
            <div className="dashboard-box">
              <span><img src="/images/active-matches.svg" alt="icon" /></span>
              <h4>Premium Plus Users</h4>
              <h3>{userCounts.premiumPlus.toLocaleString()}</h3>
            </div>
          </div>
        </div>

        <div className="customer-tablle-main content-mangement-table">
          <table className="table">
            <thead>
              <tr>
                <th className="name" scope="col">Plan Name</th>
                <th className="price" scope="col">Price</th>
                <th className="resumday" scope="col">Resume/Day</th>
                <th className="calltime" scope="col">Call Time</th>
                <th className="filter" scope="col">Filters</th>
                <th className="boostaer" scope="col">Booster</th>
                {/* <th className="status" scope="col">Action</th> */}
              </tr>
            </thead>
            <tbody>
              {subscriptions.length > 0 ? (
                subscriptions.map((subscription) => (
                  <tr key={subscription.id}>
                    <td className="name">{subscription.name}</td>
                    <td className="price">{formatPrice(subscription.price)}</td>
                    <td className="resumday">{subscription.resume_submissions_per_day}</td>
                    <td className="calltime">{formatCallTime(subscription.video_call_duration_minutes)}</td>
                    <td className="filter">{subscription.filters}</td>
                    <td className="boostaer">{formatBooster(subscription.profile_booster)}</td>
                    {/* <td className="action">
                      <div className="view-image">
                        <button className="btn"><img src="/images/edit-icon.svg" alt="Edit" /></button>
                      </div>
                    </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No subscription plans found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default PlanManagement;